export default __webpack_public_path__ + "static/media/IMG_5081.d3c1fe99.png";